import { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

const Skeleton = (props: ComponentProps<'div'>) => {
  const { className, ...restProps } = props;

  return (
    <div
      data-slot="skeleton"
      className={cn('bg-accent animate-pulse rounded-md', className)}
      {...restProps}
    />
  );
};

export { Skeleton };
